import register from '../register';
import dom from '../lib/util/dom.js';

register( 'investor-updates-subscribe', () => {

  const form = document.querySelector('.investor-updates-form');
  const input = document.querySelector('.updates-form__input');
  const message = document.querySelector('.updates-form__message');

  function onSubmit( e ) {
    e.preventDefault();
    const opts = { method: 'POST', url: '/email/investor-updates' };
    const payload = { email: input.value };

    if ( input.value === '' ) {
      return;
    }

    dom.ajax( opts, payload, function( err ) {
      if ( err ) {
        return showError();
      }
      input.value = '';

      showSuccess();
    });
  }

  function showMessage( msg, err ) {
    message.textContent = msg || 'An error occurred';
    message.style.display = 'block';
    if ( err ) {
      message.classList.add('error');
    } else {
      message.classList.remove('error');
    }
  }

  // show a message indicating successful submission
  function showSuccess() {
    showMessage( 'Thanks! We\'ll keep you posted.', false );
  }

  // show a message indicating unsuccessful submission
  function showError() {
    showMessage( 'Uh-oh. Please try that again.', true );
  }

  function removeMessage() {
    message.style.display = 'none';
  }

  form.addEventListener( 'submit', onSubmit );
  input.addEventListener( 'input', removeMessage );

});

export default undefined;
